<template>
  <div class="TrackingBeams">
    <b-container fluid>
      <b-row>
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-row>
      <b-row>
        <b-table show-empty
               dark
               sticky-header="400px"
               responsive
               :items="items"
               :fields="fields"
               :small="smallTable"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :filter="filter"
               @filtered="onFiltered"
      >
        <template #cell(status)="row">
          GBO:
          <b-icon v-if="row.item.status.gbo.icon" :icon="row.item.status.gbo.icon" aria-hidden="true" font-scale="1.5" :variant="row.item.status.gbo.variant" :animation="row.item.status.gbo.animate"></b-icon>
          <b-icon v-else icon="three-dots" font-scale="1.5"></b-icon>
          Allenby:
          <b-icon v-if="row.item.status.allenby.icon" :icon="row.item.status.allenby.icon" aria-hidden="true" font-scale="1.5" :variant="row.item.status.allenby.variant" :animation="row.item.status.allenby.animate"></b-icon>
          <b-icon v-else icon="three-dots" font-scale="1.5"></b-icon>
        </template>
      </b-table>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
var fields = [
  {key: 'observation_id', label: 'Observation ID', sortable: true, 'class': 'text-center'},
  {key: 'status', label: 'Observation Status', sortable: true, 'class': 'text-center'},
  {key: 'unix_utc_start', label: 'Starts In', sortable: true, 'class': 'text-center'},
  {key: 'unix_utc_end', label: 'Ends In', sortable: true, 'class': 'text-center'}
]
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      eventNum: null,
      items: [],
      fields: fields,
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      plot: null,
      sortBy: 'unix_utc_start',
      sortDesc: false,
      filter: null
    }
  },
  mounted () {
    // this.refreshToken()
    this.fetchEvents()
    setInterval(this.fetchEvents, 5000)
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    fetchEvents () {
      var url = 'https://frb.chimenet.ca/maestro/coordination-webserver/webapi/tracking-beam-status'
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseSchedule(response.body)
        })
    },
    parseSchedule (events) {
      // events.reverse()
      this.items = []
      const iconmap = {'COMPLETED': 'check-square-fill', 'FAILED': 'x-square-fill', 'STARTED': 'arrow-clockwise'}
      const variantmap = {'COMPLETED': 'success', 'FAILED': 'danger', 'SCHEDULED': 'info', 'STARTED': 'warning'}
      const animatemap = {'COMPLETED': 'null', 'FAILED': 'null', 'STARTED': 'spin-pulse'}
      for (var i = 0; i < events.length; i++) {
        let item = events[i]

        item['status'] = {
          gbo: {icon: iconmap[item.status.gbo], variant: variantmap[item.status.gbo], animate: animatemap[item.status.gbo]},
          allenby: {icon: iconmap[item.status.allenby], variant: variantmap[item.status.allenby], animate: animatemap[item.status.allenby]}
        }

        item['_rowVariant'] = 'secondary'
        let startsIn = item['unix_utc_start'] - Math.floor(Date.now() / 1000)
        let endsIn = item['unix_utc_end'] - Math.floor(Date.now() / 1000)
        // let duration = item['unix_utc_end'] - item['unix_utc_start']
        item['unix_utc_end'] = parseInt(endsIn)
        item['unix_utc_start'] = parseInt(startsIn)
        if (startsIn > -1800) {
          this.items.push(item)
        }
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outriggers/tracking_beam.vue